import {
  fetchTokenRepo,
  fetchTokenByRefreshRepo,
  fetchUserRepo,
  logoutUserRepo,
  postUserActivityRepo,
  getUserActivityRepo,
  getIdpPermissionsRepo,
  getUserKeywordsRepo,
  postUserKeywordsRepo,
  putUserDetailRepo,
  fetchAuthUserPermissionRepo,
  commonSignInCheckRepo,
  postValidateFieldsRepo,
} from "../../repositories/user";
import Cookies from "universal-cookie";
import axios from "axios";


export const fetchToken = (data) => {
  return (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    fetchTokenRepo(data)
      .then((response) => {
        dispatch({ type: "LOADING", payload: false });
        const cookies = new Cookies();
        const domain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
        cookies.set("ncms_c360_jwt_refresh", response.data?.data?.cookies.ncms_c360_jwt_refresh, {
          path: "/",
          expires: new Date(response.data.data.cookies.refresh_expiry_time * 1000 + 1000),
          domain,
          sameSite: "Lax",
        });
        cookies.set("ncms_c360_jwt_access", response.data.data.cookies.ncms_c360_jwt_access, {
          path: "/",
          expires: new Date(response.data.data.cookies.access_expiry_time * 1000 + 1000),
          domain,
          sameSite: "Lax",
        });
        cookies.set("ncms_session_cookie", response.data?.data?.user_session_data.ncms_sid, {
          path: "/",
          expires: new Date(response.data?.data?.cookies.session_expiry_time * 1000 + 1000),
          domain,
          sameSite: "Lax",
        });
        cookies.set("ncms_cloudfront", response.data?.data?.user_session_data.cloudfront_cookie_value, {
          path: "/",
          expires: new Date(response.data?.data?.cookies.session_expiry_time * 1000 + 1000),
          domain,
          sameSite: "Lax",
        });
        cookies.set("ncms_sessionid", response.data?.data?.cookies?.ncms_sessionid, {
          path: "/",
          expires: new Date(response.data?.data?.cookies.session_expiry_time * 1000 + 1000),
          domain,
          sameSite: "Lax",
        });
         window.location.reload();    
        // dispatch({ type: "SET_FETCH_USERTOKEN_IN_STATE", payload: response.data });
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "LOGIN_ERROR",
            payload: error.response?.data?.data?.message,
          });
        }
      });
  };
};

export const fetchTokenByRefresh = () => {
  return (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    fetchTokenByRefreshRepo()
      .then((response) => {
        const res = response.data;
        dispatch(fetchUser());
      })
      .catch((error) => {
        if (error && error.response) {
          // dispatch(setTokenError(error.response.data.detail))
        }
      });
  };
};

export const fetchUser = (params) => {
  const cookies = new Cookies();
  const domain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
  let sessionKey = ''
  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes("ncms_session_cookie") && !value?.includes("ncms_sessionid"))
      sessionKey = value
  })
  const sessionValue = cookies.get(sessionKey);
  return async (dispatch) => {
    dispatch({ type: "LOADING", payload: false });
    await fetchUserRepo(sessionValue)
      .then((response) => {
        const cookies = new Cookies();
        cookies.set("adb_id", response.data?.data.id, {
          path: "/",
          expires: new Date(response.data.data.access_expires * 1000 + 1000),
          domain,
          sameSite: "Lax",
        });

        dispatch({ type: "SET_USER_IN_STATE", payload: response.data });
        cookies.set("identity_number", response.data.data.id, {
          path: "/",
          expires: new Date(response.data * 1000 + 1000),
          sameSite: "Lax",
        });
      })
      .catch((error) => {
        // if (
        //   error &&
        //   error.response &&
        //   error.response.headers &&
        //   error.response.headers["www-authenticate"] == "409"
        // ) {
        //   // dispatch(fetchTokenByRefresh());
        // } else {
        // dispatch({ type: "TOKEN_ERROR", payload: error });
        // }
        dispatch({ type: "TOKEN_ERROR", payload: "User Not Authenticated" });
      });
  };
};

export const fetchAuthUserPermission = () => {
  const cookies = new Cookies();
  let sessionKey = ''
  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes("SESS") && !value?.includes("CSES"))
      sessionKey = value
  })
  const sessionValue = cookies.get(sessionKey);
  return (dispatch) => {
    fetchAuthUserPermissionRepo(sessionValue).then((response) => {
      dispatch({ type: "SET_PERMISSIONS_IN_STATE", payload: response.data });
    });
  };
};

export const loginUser = (data) => {
  return (dispatch) => {
    dispatch(fetchToken(data));
  };
};

export const logoutUser = (params) => {
  const searchParams = new URLSearchParams(location.search);
  return (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    logoutUserRepo(params)
      .then((response) => {
        const cookies = new Cookies();
        const domain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;

        cookies.remove("ncms_c360_jwt_refresh", { path: "/", domain, sameSite: "Lax" });
        cookies.remove("ncms_c360_jwt_access", { path: "/", domain, sameSite: "Lax" });
        cookies.remove("ncms_session_cookie", { path: "/", domain, sameSite: "Lax" });
        cookies.remove("ncms_cloudfront", { path: "/", domain, sameSite: "Lax" });
        cookies.remove("ncms_sessionid", { path: "/", domain, sameSite: "Lax" });
        cookies.remove("rgData");
        searchParams.delete('click_location');
        searchParams.delete('ftype');
        
        // Reload the page with the updated URL
        window.location.reload();

        dispatch({ type: "LOGOUT_USER" });
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({ type: "LOADING", payload: false });
        }
      });
  };
};

export const captureUserActivity = (requestData) => {
  return (dispatch) => {
    postUserActivityRepo(requestData)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_USER_ACTIVITY_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "POST_USER_ACTIVITY_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "POST_USER_ACTIVITY_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const fetchUserActivity = () => {
  return async (dispatch) => {
    await getUserActivityRepo()
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_USER_ACTIVITY_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "GET_USER_ACTIVITY_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_USER_ACTIVITY_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getIdpPermissions = (params) => {
  return (dispatch) => {
    getIdpPermissionsRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_IDP_PERMISSION_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "GET_IDP_PERMISSION_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_IDP_PERMISSION_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getUserKeywords = (params) => {
  return (dispatch) => {
    getUserKeywordsRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_USER_KEYWORD_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "GET_USER_KEYWORD_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_USER_KEYWORD_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postUserKeywords = (data) => {
  return (dispatch) => {
    postUserKeywordsRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_USER_KEYWORD_SUCCESS",
            payload: response.data,
          });
          return response.data;
        } else {
          dispatch({
            type: "POST_USER_KEYWORD_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "POST_USER_KEYWORD_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const putUserDetail = (id, data) => {
  const cookies = new Cookies();
  cookies.remove("c360_user_data", { path: "/" });

  return (dispatch) => {
    putUserDetailRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({ type: "PUT_USER_DETAIL_SUCCESS", payload: response.data });
          dispatch(fetchUser());
        } else {
          dispatch({
            type: "PUT_USER_DETAIL_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "PUT_USER_DETAIL_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCommonSignInCheck = (data) => {
  return (dispatch) => {
    dispatch({
      type: "POST_COMMON_SIGNIN_CHECK_LOADING",
    });
    commonSignInCheckRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_COMMON_SIGNIN_CHECK_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "POST_COMMON_SIGNIN_CHECK_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "POST_COMMON_SIGNIN_CHECK_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postValidateFields = (data) => {
  return (dispatch) => {
    dispatch({
      type: "POST_VALIDATE_FIELDS_LOADING",
    });
    postValidateFieldsRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_VALIDATE_FIELDS_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "POST_VALIDATE_FIELDS_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "POST_VALIDATE_FIELDS_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};
